// extracted by css-extract-rspack-plugin
export default {"title":"QfJAbHWF8EYpdukr","meter":"HeppSNak4t0m8p4R","summary":"vriQk5u7eEQbgw70"};